module.exports = __webpack_public_path__ + "img/7d2edd3cb8b764d31ed398d176bc8796.png";